module.exports = __webpack_public_path__ + "static/img/logo-innovare-dark.6cffabc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-innovare-dark.png
// module id = 8ZlS
// module chunks = 3